import React from 'react';
import {Component} from 'react';
import PropTypes from 'prop-types';
import BlankComponent from "../BlankComponent/BlankComponent";

import Skeleton from "../Skeleton/Skeleton";
import ContentRenderer from "../ContentRenderer/ContentRenderer"

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";


class ContentAccordion extends Component {

  state = {
    template: <Skeleton type="IFRAME"/>,
    selected: this.props.selected
  };

  componentDidMount() {
    this.fetchData();
  }
  
  fetchData = async () => {
    try {
      const response = await fetch(this.props.jsonDataUrl);
      this.json = await response.json();
      
      if (response.ok) {
        this.setState({
          template: this.getTemplate()
        });
      } else {
        this.setState({
          template: this.props.errorTemplate || <Skeleton type="IFRAME_ERROR"/>
        });
      }
    } catch (e) {
      this.setState({
        template: this.props.errorTemplate || <Skeleton type="IFRAME_ERROR"/>
      });
    }
  };
  
  getTemplate(selectedKey) {
    
    if (this.props.isCategorized) {
      return this.getCategorizedTemplate(selectedKey, this.json);
    } else {
      return this.getSimpleTemplate(selectedKey, this.json);
    }
    
  }
  
  getSimpleTemplate(selectedKey, accordionData) {
    return accordionData.map(item => (
      <ExpansionPanel
        key={item.id + "Panel"}
        className="accordion__header-container"
        expanded={item.id === selectedKey}
        onChange={event => this.handlePanelExpansion(event, item.id)}>
        <ExpansionPanelSummary
          className="accordion__header"
          expandIcon={<ExpandMoreIcon className="accordion__expand-icon"/>}>
          <div className="accordion__title">{item.title}</div>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className="accordion__content">
          <ContentRenderer
            contentType={item.content.type}
            value={item.content.value}
          />
        </ExpansionPanelDetails>
      </ExpansionPanel>));
  }
  
  getCategorizedTemplate(selectedKey, accordionData) {
    
    return accordionData.categories.map(item => (
        <BlankComponent key={item.category}>
          <h4 ref={this.props.selected.trim() === item.category.trim() ? this.props.setRef : null} className="mvl">{item.category}</h4>
          {this.getSimpleTemplate(selectedKey, item.faqs)}
        </BlankComponent>
      )
    );
  }
  
  handlePanelExpansion(event, key) {
    
    this.key = key === this.key ? null : key;
    
    this.setState({
      template: this.getTemplate(this.key, this.json)
    });
  }
  
  render() {
    return this.state.template;
  }
}

export default ContentAccordion;

ContentAccordion.propTypes = {
  jsonDataUrl: PropTypes.string,
  isCategorized: PropTypes.bool
};




// WEBPACK FOOTER //
// ./src/components/ContentAccordion/ContentAccordion.js